import { ConversationSummaryRaw } from 'src/types';

export const getLatestSummary = (
  summaries?: ConversationSummaryRaw[] | null,
): ConversationSummaryRaw | null => {
  if (!Array.isArray(summaries) || summaries.length === 0) {
    return null;
  }

  const activeSummaries = summaries.filter((summary) => !summary?.deletedAt);
  if (activeSummaries.length === 0) {
    return null;
  }

  const toTime = (value?: string | null) => {
    if (!value) return 0;
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  return activeSummaries.reduce<ConversationSummaryRaw | null>((latest, summary) => {
    if (!summary) return latest;

    const summaryTime = toTime(summary.updatedAt) || toTime(summary.createdAt);
    if (!latest) return summary;

    const latestTime = toTime(latest.updatedAt) || toTime(latest.createdAt);
    return summaryTime > latestTime ? summary : latest;
  }, null);
};
